import { call, put, select } from 'redux-saga/effects';
import { iActionCreate } from '~/domain/interfaces/redux/professionalList/create';
import { CreateProfessional } from '~/domain/usecases/professionalList/remote/CreateProfessional';
import { makeRemoteCreateProfessional } from '~/main/factories/usecases/professional/CreateProfessionalFactory';
import {
  createSuccess,
  createFailed,
} from '~/data/store/reducer/Professional/actions/create';
import { makeReduxActiveMessage } from '~/main/factories/usecases/message/Update';
import { MessageOptions } from '~/domain/interfaces/redux/message';
import { History } from '~/main/routes';
import { closeModal } from '~/utils/closeModal';

export function* onCreate(action: iActionCreate) {
  const remoteCreateProfessional = makeRemoteCreateProfessional();

  try {
    const response: CreateProfessional.Model = yield call(
      remoteCreateProfessional.create,
      action.payload,
    );

    makeReduxActiveMessage().active({
      active: MessageOptions.userCreateSuccess,
      actionOk: () => {
        History.back();
        closeModal();
      },
    });

    yield put(
      createSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(createFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateFailed() {}
